import { ReactNode } from 'react';
import { BoxProps as MuiBoxProps } from '@mui/material/Box';

import {
  ButtonWrapper,
  Description,
  IconWrapper,
  Title,
  Wrapper,
} from './styles';
import basketEmptyIcon from '../../../../../assets/images/paymentJourney/empty-basket.png';

export interface PaymentJourneyMessageProps extends MuiBoxProps {
  title: string;
  description: ReactNode;
  button: ReactNode;
  icon?: ReactNode;
}

export default function PaymentJourneyMessage(
  props: PaymentJourneyMessageProps,
) {
  const {
    icon = <img src={basketEmptyIcon} alt="" />,
    title,
    description,
    button,
    ...restProps
  } = props;

  return (
    <Wrapper {...restProps}>
      <IconWrapper>{icon}</IconWrapper>
      <Title variant="subtitle1" neutralColorIndex={800}>
        {title}
      </Title>
      <Description variant="body1" neutralColorIndex={600} component="div">
        {description}
      </Description>
      <ButtonWrapper>{button}</ButtonWrapper>
    </Wrapper>
  );
}
